export const sortArrayOfObjects = <T>(
  data: T[],
  keyToSort: any,
  direction: "ascending" | "descending" | "none"
): T[] => {
  if (direction === "none") {
    return data;
  }
  const compare = (objectA: any, objectB: any) => {
    let valueA, valueB;
    
    /** For Competitor Page Sorting Variation */
    if (keyToSort.includes('competitor')) {
      const index :any= keyToSort[keyToSort.length - 1]
      valueA = objectA['competitorDetails'][index][keyToSort.slice(0, -1)]
      valueB = objectB['competitorDetails'][index][keyToSort.slice(0, -1)]
    }
    else {
      valueA = objectA[keyToSort];
      valueB = objectB[keyToSort];
    }
    if (valueA === valueB) {
      return 0;
    }

    if (valueA > valueB) {
      return direction === "ascending" ? 1 : -1;
    } else {
      return direction === "ascending" ? -1 : 1;
    }
  };

  return data.slice().sort(compare);
};
